<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">印刷設定</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
        <tr>
          <th class="th_type">設定項目の選択</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="disaster in disasters" v-bind:key="disaster.id">
          <td class="td_type">
            <router-link v-on:click.native="selectDisasterType(disaster.disaster_id)" to="">{{ disaster.disaster_name }}</router-link>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                disasters: null,
                // メッセージ
                message: ""
            }
        },
        mounted() {
            this.getDisasterTypeList()
        },
        methods: {
            async getDisasterTypeList() {
                const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'disaster/list', {
                    params: {
                        municipality_key: this.$store.getters.getStateMunicipalityKey
                    }
                })
                this.disasters = response.data
            },
            selectDisasterType: function(disaster_id) {
                this.$store.commit('setStateChangeFlg', true)
                this.$store.commit('setStatePrintDisasterId', disaster_id)
                this.$router.push({ name: 'printDetail' })
            },
            disasterTypeAdd: function() {
                // 変更フラグ
                this.$store.commit('setStateChangeFlg', false)
                this.$router.push({ name: 'disasterTypeDetail' })
            },
            disasterTypeUpdate: function(disaster_id) {
                // 変更フラグ
                this.$store.commit('setStateChangeFlg', true)
                // 災害種別コードをStoreにセット
                this.$store.commit('setStateDisasterId', disaster_id)
                this.$router.push({ name: 'disasterTypeDetail' })
            }
        }
    }
</script>


<style scoped>
  .description {
    font-size: 14px;
    text-align: left;
  }
  table th.th_type, table td.td_type {
    text-align: left;
    padding-left: 10px;
    padding-right: 10px;
  }

  .mark_box {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: 10px 10px 0px 0px;
  }
  .mark_outer {
    display: table;
    margin: 0px 0px 10px 10px;
  }
  .mark_inner {
    background-color: rgb(192,192,192);
    width: 45px;
    height: 45px;
    text-align: center;
    font-family: Arial;
    display: table-cell;
    vertical-align: middle;
    border-radius: 7px 7px 7px 7px;
    color: #F4F4F4;
  }

  .btn_up {
    text-align: right;
    font-size: 15px;
    border-right: none;
    width: 25px;
  }
  .btn_down {
    text-align: left;
    font-size: 15px;
    border-left: none;
    border-right: none;
    width: 25px;
  }
  .btn_delete {
    text-align: left;
    border-left: none;
    width: 20px;
  }
  .btn_updown {
    background-color: transparent;
    border: none;
    cursor: pointer;
    outline: none;
    padding: 0;
    appearance: none;
  }
</style>